import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import SendexPro from "@/pages/SendexPro";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import ChatWidget from "@/components/ChatWidget";
import { initLenis, scrollToTop } from "@/lib/scroll";
import { LanguageProvider } from "@/lib/i18n";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollToTop(true);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ventures/sendexpro" element={<SendexPro />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
        <ChatWidget />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
      </LanguageProvider>
    </div>
  );
}

export default App;
